import { render, staticRenderFns } from "./repair.vue?vue&type=template&id=0ba0c396&scoped=true"
import script from "./repair.vue?vue&type=script&lang=ts"
export * from "./repair.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0c396",
  null
  
)

export default component.exports